import { createRangeFilter } from '@adv-frontend/filters';
import { SORT_WEIGHT_FILTER_ID, SORT_WEIGHT_FILTER_TITLE } from '../../constants';

export const createSortWeightFilter = () =>
    createRangeFilter({
        id: SORT_WEIGHT_FILTER_ID,
        title: SORT_WEIGHT_FILTER_TITLE,
        availableOperators: 'all',
    });
